import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { StorageContext } from '@juvare/platform-app/App';
import { StorageBackendApi } from '@juvare/platform-app/Storage';

export function getExtendedAccountStorage(context: StorageContext): StorageBackendApi<ExtendedAccountData, ExtendedAccountColumns> {
    return context.storage<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName);
}
